import React from 'react'
import header from './bg-header-desktop.svg'

function Heading() {
    return (
        <div>
        <img src={header} alt="This is a banner" className='headerImg'/>
        </div>
    )
}

export default Heading
